import { useContext, useEffect } from 'react';

import { DocumentTitleContext } from './DocumentTitleContext';

export const useDocumentTitleAffix = (affix) => {
  const { setTitleAffix } = useContext(DocumentTitleContext);
  useEffect(() => {
    setTitleAffix(affix);
  }, [affix]);
};
